import { backendBaseUrl } from '../utils/platformBasedInfo';
import { useAxios } from './axiosInstance';

export const ENDPOINT_GET_BCM_BILLING_CONFIG = `${backendBaseUrl}/v1/bcm/subscription/billing-config`;

export type BcmBillingConfig = {
  enabled: boolean;
  /** Server-driven flag for the Apply /bcm flow's post-signup card step. */
  applyCardStepEnabled: boolean;
  provider: 'quickbooks';
  tokenizeUrl: string;
  /** Public OAuth client id for the browser tokenization call's header. */
  clientId: string;
  priceMonthly: string;
  trialMonths: number;
};

export type BcmBillingConfigResponse = {
  message: string;
  data?: BcmBillingConfig;
};

export const getBcmBillingConfig = () =>
  useAxios({
    url: ENDPOINT_GET_BCM_BILLING_CONFIG,
    withCredentials: true,
    method: 'GET',
  });
